import { checkCustomerIdentity } from './rules.js';
import { customerEditFormFieldsSchema } from './update-form.js';
/** Payment and ship terms are optional on create: the server fills the catalog defaults (R3). */
export const customerCreateFormSchema = customerEditFormFieldsSchema.superRefine((values, context) => {
    for (const issue of checkCustomerIdentity(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
//# sourceMappingURL=create-form.js.map